import { render } from "./ClubPointRules.vue?vue&type=template&id=035fca73&ts=true"
import script from "./ClubPointRules.vue?vue&type=script&lang=ts"
export * from "./ClubPointRules.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__